import axios from 'axios';
import { config } from './Config/Config';

const END_POINTS = {
  RESET_PASSWORD: '/v4/auth/resetPassword',
  RESET_PASSWORD_FOR_SPECIAL_SERVER: '/resetPassword',
  GET_PASSWORD_POLICY: '/v4/auth/passwordPolicy',
  VERIFY_EMAIL: '/v4/auth/verifyEmail',
  COMPLETE_CHANGE_EMAIL: '/v4/auth/completeChangeEmail'
};

function resetPassword(token, newPassword) {
  const reqData = {
    identity: token,
    password: newPassword,
  };
  if (config.serverForResetPassword) {
    return axios.post(`${config.serverForResetPassword}${END_POINTS.RESET_PASSWORD_FOR_SPECIAL_SERVER}`, reqData);
  }
  return axios.post(`${config.server}${END_POINTS.RESET_PASSWORD}`, reqData);
}

function verifyEmail(token) {
  return axios.post(`${config.server}${END_POINTS.VERIFY_EMAIL}`, {
    token: token,
  });
}

function verifyChangeEmail(token, email) {
  return axios.post(`${config.server}${END_POINTS.COMPLETE_CHANGE_EMAIL}`, {
    token: token,
    email: email
  });
}

function getPasswordPolicy(userRole) {
  return axios.get(`${config.server}${END_POINTS.GET_PASSWORD_POLICY}?userRole=${userRole}`);
}

export const NetworkApi = {
  resetPassword,
  getPasswordPolicy,
  verifyEmail,
  verifyChangeEmail
};
